import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {emptyResumo, ResumoVo} from '~model/vo/resumo-vo';
import {state, style, trigger} from '@angular/animations';
import {DocumentosService} from '~core/api/documentos.service';
import {ParamService} from '~core/utils/param.service';
import {indexIcon, zIndexStatusMonitoramento} from '~utils/zindex-status-monitoramento';
import {downloadFile} from '~utils/file-utils';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatTabGroup} from '@angular/material/tabs';
import {PrintService} from '~core/utils/print.service';
import {ResumoRotaDialogComponent} from '../resumo-rota/resumo-rota-dialog.component';
import {RotaService} from '~core/api/rota.service';
import {asyncScheduler, BehaviorSubject, combineLatest, forkJoin, Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {entityRotaSelectById} from '~entity/entity-rota/entity-rota.selectors';
import {filter, map, observeOn, take, takeUntil} from 'rxjs/operators';
import {ArquivoVo, RotaVo, TipoGPSEnum} from '~model/vo/rota-vo';
import {List} from 'immutable';
import {entityDocumentoSelectById} from '~entity/entity-documento/entity-documento.selectors';
import {ArquivoRecibo, emptyDocumento, EntityDocumento, LinkVo} from '~entity/entity-documento/entity-documento.model';
import {clearEntityDocumentos, upsertEntityDocumento} from '~entity/entity-documento/entity-documento.actions';
import {DocumentoArquivo} from '~model/interfaces/documento-arquivo';
import {emptyResumoPoi, ResumoPoiVo} from '~model/vo/resumo-poi-vo';
import {environment} from '~env/environment';
import {compare, compareNum} from '~utils/list-utils';
import {TranslateService} from '@ngx-translate/core';
import {Incidente} from '~model/vo/tipos-incidentes-vo';
import {getAuth} from '~feature/feature-auth/feature-auth.selectors';
import {entityConfigCamposGrid, entityConfigParametros} from '~ngrx/entitys/entity-configuracao/entity-configuracao.selectors';
import {AppConfigService} from '~core/background/app-config.service';
import { RelatoriDinamicoXlsDialogComponent } from '../relatorio-dinamico-xls/relatorio-dinamico-xls-dialog.component';
import { RelatoriDinamicoXlsComponent } from '../relatorio-dinamico-xls/relatorio-dinamico-xls.component';
import { ProxyApp } from '~env/proxy';
import { RotaDetalhesRelatorioVO } from '~model/vo/RelatorioTabelaVO';
import { CardResumoDataService } from '~shared/services/card-resumo-data.service';
import { entityCardSelectById } from '~entity/entity-card/entity-card.selectors';
import { EntityCard } from '~entity/entity-card/entity-card.model';
import { entityIndicadorSelectById } from '~entity/entity-indicador/entity-indicador.selectors';
import { EntityIndicador } from '~entity/entity-indicador/entity-indicador.model';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { emptyFinanceiroType, FinanceiroType } from '~model/vo/grupo-usuario';
import { emptyParametros, ParametrosVo } from '~model/vo/parametros-vo';

@Component({
  selector: 'app-rota-detalhes-dialog',
  templateUrl: './rota-detalhes-dialog.component.html',
  styleUrls: ['./rota-detalhes-dialog.component.scss'],
  providers: [DocumentosService, PrintService],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
      state('expanded', style({height: '*'})),
    ]),
  ],
})
export class RotaDetalhesDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('matTabGroup') matTabGroup!: MatTabGroup;
  @ViewChild('relatorioDinamicoXls') relatorioDinamicoXls!: RelatoriDinamicoXlsComponent;
  proxy: ProxyApp = environment.proxy;

  private destroy$ = new Subject<void>();

  data: string = '';

  resumo$: BehaviorSubject<ResumoVo> = new BehaviorSubject<ResumoVo>(emptyResumo());

  tiposRastreamentoPermitidos?: TipoGPSEnum = undefined;
  rotaDetalhesRelatorio?: RotaDetalhesRelatorioVO;

  loaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadedDownload$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  arquivos: List<ArquivoVo> = List<ArquivoVo>([]);
  docLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  documentos$: BehaviorSubject<DocumentoReferencia[]> = new BehaviorSubject<DocumentoReferencia[]>([]);
  recibos$: BehaviorSubject<(ArquivoRecibo & LinkVo & { data: Date })[]> = new BehaviorSubject<(ArquivoRecibo & LinkVo & { data: Date })[]>([]);
  adiantamento$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  despesas$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  exibeRecibos$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  statusTranslationMap: Map<string, string> = new Map<string, string>([
    ['pendente', 'PENDING'],
    ['cancelada', 'CANCELLED'],
    ['chegando', 'ARRIVING'],
    ['chegou', 'ARRIVED'],
    ['realizando', 'CARRYING_OUT'],
    ['problema_realizar', 'ISSUE_WHILE_CARRYING_OUT'],
    ['problema_sair', 'ISSUE_WHILE_DEPARTING'],
    ['realizada', 'CARRIED_OUT'],
    ['atraso', 'DELAYED'],
    ['não realizado', 'NOT_CARRIED_OUT'],
  ]);
  camposGrid:string[] = [];
  nomeRota:string = '' ;

  // Propriedades para controle de abas e modo de visualização
  selectedTabIndex: number = 0;
  viewMode: 'list' | 'image' = 'list';

  // Dados dos cards pedidos e visitas
  cardPedidos$: BehaviorSubject<EntityCard | null> = new BehaviorSubject<EntityCard | null>(null);
  cardVisitas$: BehaviorSubject<EntityCard | null> = new BehaviorSubject<EntityCard | null>(null);
  indicadorPedidos$: BehaviorSubject<EntityIndicador | null> = new BehaviorSubject<EntityIndicador | null>(null);
  indicadorVisitas$: BehaviorSubject<EntityIndicador | null> = new BehaviorSubject<EntityIndicador | null>(null);

  exibeAbaRecibos: boolean = false;

  financeiroGrupo: FinanceiroType = emptyFinanceiroType();
  parametros: ParametrosVo = emptyParametros();
  userRoles: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public id: string,
    private rotaService: RotaService,
    private documentosService: DocumentosService,
    private store: Store,
    private appConfig: AppConfigService,
    private param: ParamService,
    private printService: PrintService,
    private snackbar: MatSnackBar,
    public dialog: MatDialog,
    private translate: TranslateService,
    private cardResumoDataService: CardResumoDataService,
    private router: Router,
    private jtw: JwtHelperService
  ) {
  }

  ngOnInit(): void {
    const currentRoute = this.router.url;
    this.exibeAbaRecibos = currentRoute.includes('/financeiro');
    
    this.rotaService.getResumo(this.id)
      .pipe(observeOn(asyncScheduler, 500)).subscribe((res = emptyResumo()) => {
        if (res.executado.tipoRastreamento) {
          this.tiposRastreamentoPermitidos = res.executado.tipoRastreamento;
        }
      if (!res.resumoPOIs) {
        res.resumoPOIs = [];
      }

      for (const resumo of res.resumoPOIs) {
        const status = resumo.status.toString().toLowerCase();
        const textID = indexIcon(resumo.servicos.map(e => e.tipo)) || 0;
        resumo.icon = {
          iconID: (zIndexStatusMonitoramento[status] && zIndexStatusMonitoramento[status][0]) || 0,
          textID,
        };
      }
      this.resumo$.next(res);
      console.log('-----> resumo', res);

      // Carregar dados dos cards pedidos e visitas
      this.carregarDadosCards();

      this.adiantamento$.next(res.adiantamento ?? 0);
      this.openDocumentos(res.id);
      this.loaded$.next(true);
    });

    this.store.pipe(select(entityRotaSelectById(this.id)))
      .pipe(filter(r => !!r), map(r => r as RotaVo))
      .subscribe(rota => {
        const list = List(rota.arquivos || []);
        if (!this.arquivos.equals(list)) {
          this.arquivos = list;
          this.openDocumentos(rota.id);
        }
      });

    this.store.select(getAuth).subscribe(auth => {
      if (auth.tokenRules && this.jtw.decodeToken(auth.tokenRules).grupo) {
        this.financeiroGrupo = this.jtw.decodeToken(auth.tokenRules).grupo.financeiro;
      }
    });

    combineLatest([
      this.store.select(entityConfigParametros(this.appConfig.empresa)).pipe(filter(parametros => !!parametros)),
      this.store.select(getAuth).pipe(observeOn(asyncScheduler))
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([parametros, { roles }]) => {
      this.parametros = parametros;
      this.userRoles = roles;
      this.ativaAbaRecibos();
    });

    this.translate.get('ROUTE_REPORT').subscribe({
      next: routeReportStrings => {
        this.store.pipe(select(entityDocumentoSelectById(this.id)))
          .subscribe(res => {
            const loadedDownloads = !(res === undefined);
            res = res || emptyDocumento();
            const referenciasList: DocumentoReferencia[] = [];
            for (const arquivo of res.arquivos) {
              const resumoPOI = this.resumo$.value.resumoPOIs.find(({servicos, codigo}) =>
                  servicos.findIndex(s => s.codigo === arquivo.servico) >= 0 || codigo === arquivo.visita)
                || emptyResumoPoi();
              const file = {...arquivo, data: new Date(arquivo.criacao)};
              const tipo = this.arquivos.filter(f => f.listaArquivos.findIndex(a => a === file.nome) >= 0)
                .map(f => TipoDocumento[f.tipo] || f.tipo).first(routeReportStrings.DOCUMENTS.UNDEFINED);

              referenciasList.push({
                arquivo: file,
                pedido: resumoPOI,
                tipo,
                incidente: arquivo.incidente,
                statusKey: resumoPOI.status ? 'SERVICES.STATUS.' + this.statusTranslationMap.get(resumoPOI.status.toLowerCase()) : '',
              });
            }
            this.documentos$.next(referenciasList.sort(compareArquivos));
            this.recibos$.next(res?.recibos?.map(m =>
              ({...m, ...m.links[0], data: new Date(m.timestamp)})) ?? []);
            this.despesas$.next(res?.recibos?.reduce((acc, r) => (r.valor ?? 0) + acc, 0) ?? 0);
            this.loadedDownload$.next(loadedDownloads);
          });
      },
    });

    this.store.select(entityConfigCamposGrid(this.appConfig.empresa)).subscribe(list =>  this.camposGrid = list);

    this.rotaService.getTableResumo(this.id).subscribe({
      next: (resumo: RotaDetalhesRelatorioVO) => {
        this.rotaDetalhesRelatorio = resumo;
      },
      error: (error) => {
        console.error('Erro ao buscar resumo da rota:', error);
      },
    });
  }

  ngAfterViewInit(): void {
    this.data = this.data || this.param.dataMonitoramento;
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }); // BUGFIX FOR NGX-CHARTS
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ativaAbaRecibos(): void {
    // Verifica se o usuário tem o perfil financeiro ou se o grupo financeiro está ativo para visualização de rotas
    // financeiroGrupo.visualizacaoRotas é um item obrigatório a ser marcado caso queiramos ativar o módulo financeiro no Operador
    const isFinanceiro = this.userRoles.includes('Financeiro') || this.financeiroGrupo.visualizacaoRotas;

    // Como pode vir undefined, garantimos que seja um booleano
    const prestacaoContasAtivado = this.parametros.ativaPrestacaoContas ? this.parametros.ativaPrestacaoContas : false;

    // Verifica se a prestação de contas está ativa e se o usuário é do perfil financeiro ou se o grupo financeiro está ativo
    const exibeRecibos = prestacaoContasAtivado && isFinanceiro;

    this.exibeRecibos$.next(exibeRecibos);
  }

  openResumoRota(): void {
    this.dialog.open(ResumoRotaDialogComponent, { width: '80rem', data: this.resumo$.value, autoFocus: false });
  }

  printRelatorio(): void {
    this.printService.printComponent('resumo-rota-xls', 'resumo', this.resumo$.value);
  }

  printRelatorioCustom(): void {
    this.printService.printComponent('relatorio-custom-pdf', 'resumo', this.rotaDetalhesRelatorio);
  }

  printRelatorioCustomXls(): void {
    // Chama o método baixarXls do componente na aba ao invés de abrir dialog
    if (this.relatorioDinamicoXls) {
      this.relatorioDinamicoXls.baixarXls();
    } else {
      // Fallback para caso a referência não esteja disponível
      this.dialog.open(RelatoriDinamicoXlsDialogComponent, { width: '80rem', data: this.rotaDetalhesRelatorio, autoFocus: false });
    }
  }

  openDocumentos(id: string): void {
    this.store.dispatch(clearEntityDocumentos() as any);
    if (id) {
      this.exibeRecibos$.pipe(
        filter(exibe => !this.exibeAbaRecibos || exibe),
        take(1)
      ).subscribe(exibe => {
        if (exibe && this.exibeAbaRecibos) {
          forkJoin([
            this.documentosService.getDocumentosRota(id),
            this.documentosService.getRecibosRota(id),
          ])
            .pipe(observeOn(asyncScheduler, 500))
            .subscribe(([doc, recibos]) =>
              this.processDocument(doc, recibos ?? []));
        } else {
          this.documentosService.getDocumentosRota(id)
            .pipe(observeOn(asyncScheduler, 500))
            .subscribe(res => this.processDocument(res, []));
        }
      });
    }
  }

  processDocument(documento: EntityDocumento, recibos: ArquivoRecibo[]): void {
    this.store.dispatch(upsertEntityDocumento({entity: emptyDocumento({...documento, recibos})}) as any);
    this.docLoaded$.next(true);
  }

  download(referencia?: DocumentoReferencia | ArquivoRecibo): void {
    this.translate.get('ROUTE_REPORT.PRINTING').subscribe({
      next: printingString => {
        this.snackbar.open(printingString.DOWNLOADING, undefined, {duration: 3000});
        let observable;
        let nomeDoArquivo: string;
        if (referencia && 'arquivo' in referencia) {
          nomeDoArquivo = referencia.arquivo.nome;
          observable = this.documentosService.downloadImage(referencia.arquivo.linkDownload);
        } else if (referencia && 'links' in referencia) {
          nomeDoArquivo = referencia.links[0]?.name ?? 'file';
          observable = this.documentosService.downloadImage(referencia.links[0]?.linkDownload ?? '');
        } else {
          nomeDoArquivo = `Anexos_${this.resumo$.value.data}_${this.resumo$.value.placa}_todos.zip`;
          const arquivos = this.documentos$.getValue().map(r => ({
            pasta: r.pedido.codigo,
            link: r.arquivo.linkDownload,
          }));
          observable = this.documentosService.geraZipDocumentos(arquivos);
        }
        observable.subscribe(res => {
          const file = downloadFile(res, nomeDoArquivo, printingString.DOWNLOADED);
          this.snackbar.open(file, undefined, {duration: 3000});
        });
      },
    });
  }  // Método para carregar dados dos cards pedidos e visitas
  carregarDadosCards(): void {
    // Buscar card de pedidos
    this.store.pipe(select(entityCardSelectById('pedidos')))
      .subscribe(cardPedidos => {
        if (cardPedidos) {
          // Filtrar itens para remover "Orfãos" e "Adicionadas"
          const cardFiltrado = {
            ...cardPedidos,
            itens: cardPedidos.itens.filter(item =>
              !item.descricao.toLowerCase().includes('orfãos') &&
              !item.descricao.toLowerCase().includes('orfaos') &&
              !item.descricao.toLowerCase().includes('adicionadas')
            ),
          };
          this.cardPedidos$.next(cardFiltrado);
        }
      });

    // Buscar card de visitas
    this.store.pipe(select(entityCardSelectById('visitas')))
      .subscribe(cardVisitas => {
        if (cardVisitas) {
          // Filtrar itens para remover "Orfãos" e "Adicionadas"
          const cardFiltrado = {
            ...cardVisitas,
            itens: cardVisitas.itens.filter(item =>
              !item.descricao.toLowerCase().includes('orfãos') &&
              !item.descricao.toLowerCase().includes('orfaos') &&
              !item.descricao.toLowerCase().includes('adicionadas')
            ),
          };
          this.cardVisitas$.next(cardFiltrado);
        }
      });

    // Buscar indicador de pedidos
    this.store.pipe(select(entityIndicadorSelectById('pedidos')))
      .subscribe(indicador => {
        if (indicador) {
          this.indicadorPedidos$.next(indicador);
        }
      });

    // Buscar indicador de visitas
    this.store.pipe(select(entityIndicadorSelectById('visitas')))
      .subscribe(indicador => {
        if (indicador) {
          this.indicadorVisitas$.next(indicador);
        }
      });
  }

  possuiDocumentos(): boolean {
    return this.documentos$.getValue().length > 0;
  }

  possuiRecibos(): boolean {
    return this.recibos$.getValue().length > 0;
  }

  // Método para detectar mudança de aba
  onTabChange(event: any): void {
    this.selectedTabIndex = event.index;
  }

  // Método para alternar entre modo lista e imagem
  toggleViewMode(): void {
    this.viewMode = this.viewMode === 'list' ? 'image' : 'list';
    // Aqui você pode adicionar lógica adicional para notificar o componente filho
    // sobre a mudança de modo de visualização
  }

  // Método para definir o modo de visualização específico
  setViewMode(mode: 'list' | 'image'): void {
    this.viewMode = mode;
    // Aqui você pode adicionar lógica adicional para notificar o componente filho
    // sobre a mudança de modo de visualização
  }
}

export interface DocumentoReferencia {
  arquivo: DocumentoArquivo;
  pedido: ResumoPoiVo;
  incidente?: Incidente;
  tipo: string;
  statusKey: string;
}

export const TipoDocumento: { [key: string]: string; } = {
  XML_NOTA: 'Nota',
  IMAGEM_CARGA: 'Carga',
  IMAGEM_PESSOA: 'Pessoa',
  IMAGEM_DOCUMENTO: 'Documento',
  IMAGEM_EVENTO: 'Evento',
  PDF_DOCUMENTO: 'PDF',
  IMAGEM_FACHADA: 'Fachada',
  IMAGEM_ASSINATURA: 'Assinatura',
  IMAGEM_NOTA: 'Nota Fiscal',
  IMAGEM_OUTROS: 'Outros',
};

const compareArquivos = (a: DocumentoReferencia, b: DocumentoReferencia) => {
  const comp = compareNum(a.pedido.ordem, b.pedido.ordem) as number;
  return comp || compare(a.pedido.tipo, b.pedido.tipo) as number;
};
